import React, { useEffect } from 'react'
import { Dialog, Modal } from '@leroy-merlin-br/backyard-react'

import * as S from './successModal.styled'

type Props = {
  open: boolean
  onClose: () => void
}

export const SuccessModal: React.FC<Props> = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) {
      return
    }

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }

    window.addEventListener('keydown', onKey)

    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  return (
    <Modal isOpen={open} isCentered onClose={onClose}>
      <Dialog onClose={onClose}>
        <S.Close onClick={onClose} aria-label="Fechar">
          ×
        </S.Close>
        <S.Title>
          Parabéns! Você trocou seus
          <br />
          pontos por cashback! 🎉
        </S.Title>

        <S.Text>
          Seu cashback foi gerado com sucesso! Agora é só aproveitar. O valor
          ficará disponível para uso até o último dia do mês seguinte a partir
          da data da troca. Após esse período, ele será expirado
          automaticamente.
        </S.Text>

        <S.Text>Aproveite seus benefícios!</S.Text>
      </Dialog>
    </Modal>
  )
}
